export const VALIDATORS_REGEX = {
  DIGITS: /^\d+$/,
  ALPHABETIC: /^[a-zA-Z ]+$/,
  ALPHANUMERIC: /^[a-zA-Z0-9 ]+$/,
  UPPERCASE_LETTERS: /^[A-Z ]+$/,
  DECIMAL_NUMBER: /^[0-9.]+$/,
  AT_LEAST_ONE_LETTER: /^(?=.*[a-zA-Z]).+$/,
  COMMAS_SEPARATED_DIGITS: /^(\d+)(,\s+\d+)*$/,
  SPECIAL_CHARS_NUMBERS_ONLY: /^[0-9\-]+$/,
  TIN: /^\d{8}-\d{4}$/,
  POST_CODE: /^\d{5,6}$/,
  IPV4: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  PHONE_NUMBER_MIN_LENGTH: 9,
  PHONE_NUMBER_MAX_LENGTH: 14,
  INTERNATIONAL_PHONE_NUMBER: /^[1-9]\d{7,14}$/
};